export default "__VITE_ASSET__d9c1dfe1__"